import { render } from "./PremioDasMissoes.vue?vue&type=template&id=2050259f&scoped=true"
import script from "./PremioDasMissoes.vue?vue&type=script&lang=js"
export * from "./PremioDasMissoes.vue?vue&type=script&lang=js"

import "./PremioDasMissoes.vue?vue&type=style&index=0&id=2050259f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2050259f"]])

export default __exports__